export abstract class AbstractChatAnalyticsService {
  public abstract trackWindowOpened(params: {
    isNewChat: boolean;
    source?: string;
  }): void;

  public abstract trackMessageSent(params: {
    agent?: string;
    messageLength: number;
    hasFiles: boolean;
    fileCount: number;
    isFirstMessage: boolean;
  }): void;

  public abstract trackSuggestionClicked(params: {
    agent?: string;
    suggestionLength: number;
  }): void;

  public abstract trackResponseEnded(params: {
    agent?: string;
    partsCount: number;
  }): void;

  public abstract trackResponseFailed(params: { agent?: string }): void;

  public abstract trackApprovalAcknowledged(params: {
    agent?: string;
    actionType?: string;
  }): void;

  public abstract trackApprovalCancelled(params: { agent?: string }): void;
}
